import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useFormik } from 'formik';
import api from '../../../../../components/api';

// interface UpdateClient {
//   id: number;
//   name: string;
//   addressChanged: boolean;
//   address: {
//     streetAddress: boolean;
//     zipCode: string;
//     state: string;
//     city: string;
//   },
//   categoryId:number;
//   commision: number;
//   partnerId: number;
//   partnerCommission: number;
// }

function useEditClientDetail() {
  const { routeId, clientId } = useParams();

  /* initial fetch to get route list data from real time */
  const {
    data, isLoading,
  } = useQuery(
    ['getById', 'routes', routeId],
    () => api.routes.getById(routeId!),
    {
      enabled: !!routeId,
    },
  );

  const resData = React.useMemo(() => (
    data?.data?.data
  ), [data]);

  /* form handler */
  const formik = useFormik({
    initialValues: {
      client: '',
    },
    // validationSchema: yupSchema,
    onSubmit: async (values) => {
      console.log(values);
      // mutate(values);
    },
  });

  return {
    routeId,
    clientId,
    resData,
    formik,
    isLoading,
  };
}

export default useEditClientDetail;
